var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9c1a9abcb11d245fb80fa3a442fc7701667910b7"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kodable-web-game@kodable-y7"]={id:"9c1a9abcb11d245fb80fa3a442fc7701667910b7"};
      